import Vue from 'vue'
import axios from "axios";

export default Vue.extend({
    data() {
        return {
            regData: {
                isComposing : false
            }
        };
    },
    methods: {
        // 코드 상세 정보 가져오기
        getCode: function (grpCode) {

            let param = new Object();
            param.code = grpCode;

            let codeList = axios
                .post("/api/system/getDtlCode", param)
                .then((res) => {

                    return res.data.codeDtlInfo;
                })
                .catch((err) => console.log(err));

            return codeList;
        },
        async getCodeList(codeArray) {
            try {
                const promises = codeArray.map(grpCode => {
                    let param = { code: grpCode };
                    return axios.post("/api/system/getDtlCode", param)
                        .then(res => ({ [grpCode]: res.data.codeDtlInfo }))
                        .catch(err => {
                            console.log(err);
                            return { [grpCode]: [] };
                        });
                });

                const results = await Promise.all(promises);

                // [{ GENDER: [...] }, { STATUS: [...] }] → { GENDER: [...], STATUS: [...] }
                return results.reduce((acc, cur) => ({ ...acc, ...cur }), {});
            } catch (err) {
                console.log(err);
                return {};
            }
        },
        // 하위 코드 상세 정보 가져오기
        getDtlCode: function (parentGrpCode,parentDtlCode) {

            let param = new Object();
            param.parentGrpCode = parentGrpCode;
            param.parentDtlCode = parentDtlCode;

            let codeList = axios
                .post("/api/system/getSubDtlCodeList", param)
                .then((res) => {

                    return res.data.subDtlCodeList;
                })
                .catch((err) => console.log(err));

            return codeList;
        },
        // 우편번호 조회 호출
        fn_postSearch(call) {
            new window.daum.Postcode({
                oncomplete: (data) => { //function이 아니라 => 로 바꿔야한다.
                    // 팝업에서 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.

                    // 도로명 주소의 노출 규칙에 따라 주소를 표시한다.
                    // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
                    var roadAddr = data.roadAddress; // 도로명 주소 변수
                    //  var extraRoadAddr = ''; // 참고 항목 변수

                    // // // 법정동명이 있을 경우 추가한다. (법정리는 제외)
                    // // // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
                    // if(data.bname !== '' && /[동|로|가]$/g.test(data.bname)){
                    //      extraRoadAddr += data.bname;
                    // }
                    // // // 건물명이 있고, 공동주택일 경우 추가한다.
                    // if(data.buildingName !== '' && data.apartment === 'Y'){
                    //     extraRoadAddr += (extraRoadAddr !== '' ? ', ' + data.buildingName : data.buildingName);
                    // }
                    // // // 표시할 참고항목이 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
                    // if(extraRoadAddr !== ''){
                    //     extraRoadAddr = ' (' + extraRoadAddr + ')';
                    // }

                    // // // 우편번호와 주소 정보를 해당 필드에 넣는다.
                    // // document.getElementById('postcode').value = data.zonecode;                        
                    // // document.getElementById("roadAddress").value = roadAddr;
                    // // document.getElementById("jibunAddress").value = data.jibunAddress;

                    //postCd = data.zonecode;
                    //postCd = roadAddr;
                    //this.dispsrMbrInfo.dispsrMbrPostCd = data.zonecode;

                    // // 참고항목 문자열이 있을 경우 해당 필드에 넣는다.
                    // if(roadAddr !== ''){
                    //     document.getElementById("extraAddress").value = extraRoadAddr;
                    // } else {
                    //     document.getElementById("extraAddress").value = '';
                    // }

                    // var guideTextBox = document.getElementById("guide");
                    // // 사용자가 '선택 안함'을 클릭한 경우, 예상 주소라는 표시를 해준다.
                    // if(data.autoRoadAddress) {
                    //     var expRoadAddr = data.autoRoadAddress + extraRoadAddr;
                    //     guideTextBox.innerHTML = '(예상 도로명 주소 : ' + expRoadAddr + ')';
                    //     guideTextBox.style.display = 'block';

                    // } else if(data.autoJibunAddress) {
                    //     var expJibunAddr = data.autoJibunAddress;
                    //     guideTextBox.innerHTML = '(예상 지번 주소 : ' + expJibunAddr + ')';
                    //     guideTextBox.style.display = 'block';
                    // } else {
                    //     guideTextBox.innerHTML = '';
                    //     guideTextBox.style.display = 'none';
                    // }
                    console.log("@@@@ searchData : %o", data);
                    this.callBackAddr(call, data);
                }
            }).open();
        },
        // 금액 콤마 찍기
        fn_comma_won(price) {
            //console.log("@@@@@@ typeof : "+typeof price);

            if (price == null || price == undefined) {
                price = 0;
            }

            return price.toLocaleString('ko-KR')
        },
        getCurrentDate() {
            // 오늘 날짜
            const today = new Date();
            // 년도
            const year = today.getFullYear();
            // 월
            const month = (today.getMonth() + 1).toString().padStart(2, '0');
            // 일
            const day = today.getDate().toString().padStart(2, '0');

            const yyyy_mm_dd = `${year}-${month}-${day}`;

            return yyyy_mm_dd;

        },
        getAddMonthDate(addMoth) {
            // 오늘 날짜
            const standDate = new Date();
            standDate.setMonth(standDate.getMonth() + addMoth);

            // 년도
            const year = standDate.getFullYear();
            // 월
            const month = (standDate.getMonth() + 1).toString().padStart(2, '0');
            // 일
            const day = standDate.getDate().toString().padStart(2, '0');

            const yyyy_mm_dd = `${year}-${month}-${day}`;

            return yyyy_mm_dd;
        },
        fn_download_file(fileId) {


            let param = new Object();
            param.fileId = fileId;


            console.log("@@@@ util : %o", param);

            axios
                .post("/file/download", param, {responseType: 'blob'})
                .then((res) => {

                    console.log("@@@@ res : %o", res);

                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement('a');
                    link.href = url;

                    const disposition = res.headers["content-disposition"];

                    const fileName = decodeURI(
                        disposition
                            .match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)[1]
                            .replace(/['"]/g, "")
                            .replace("UTF-8", "")
                    );

                    console.log("@@@@@ fileName : %o", fileName);

                    link.setAttribute('download', fileName); //or any other extension
                    document.body.appendChild(link);
                    link.click();

                })
                .catch((err) => console.log(err));
        },
        formatPhoneNumber(number) {

            if (number == null) {
                return;
            }

            const onlyNumber = number.replace(/[^0-9]/g, '');

            if (onlyNumber.length === 11) {
                // 010-1234-5678
                return onlyNumber.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
            } else if (onlyNumber.length === 10) {
                // 02-1234-5678 or 031-123-4567
                if (onlyNumber.startsWith('02')) {
                    return onlyNumber.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3');
                } else {
                    return onlyNumber.replace(/(\d{3})(\d{3,4})(\d{4})/, '$1-$2-$3');
                }
            } else {
                // 그 외 숫자: 그냥 리턴
                return number;
            }
        },
        splitPhoneNumber(phone) {
            // 숫자만 남기기
            phone = phone.replace(/\D/g, "");

            if (phone.startsWith("02")) {
                return [phone.slice(0, 2), phone.slice(2, -4), phone.slice(-4)];
            } else {
                return [phone.slice(0, 3), phone.slice(3, -4), phone.slice(-4)];
            }
        },
        formatDate_YYYYMMDD(dateStr) {
            if (!dateStr || dateStr.length !== 8) return dateStr;
            const year = dateStr.substring(0, 4);
            const month = dateStr.substring(4, 6);
            const day = dateStr.substring(6, 8);
            return `${year}-${month}-${day}`;
        },
        formatPrice(value) {
            if (typeof value !== 'number') return value;
            return value.toLocaleString(); // 기본 locale 사용
        },
        toTwoDigits(num) {


            //return (num ?? 0).toString().padStart(2, '0');
            return ((num !== undefined && num !== null ? num : 0).toString().padStart(2, '0'));
        },
        formatBizNumber(input) {
            // 숫자만 남기기
            //const num = (input ?? '').replace(/\D/g, '');
            const num = ((input !== undefined && input !== null) ? input : '').replace(/\D/g, '');

            // 각 구간에 맞게 자르기
            const part1 = num.substr(0, 3);
            const part2 = num.substr(3, 2);
            const part3 = num.substr(5, 5);

            // 조합
            let result = part1;
            if (part2) result += '-' + part2;
            if (part3) result += '-' + part3;

            return result;

        },
        splitDate(inputDate) {
            // 숫자만 남기기
            inputDate = inputDate.replace(/\D/g, "");

            return [inputDate.slice(0, 4), inputDate.slice(4, 6), inputDate.slice(6)];
        },
        splitEmail(email) {
            const [mailId, domain] = email.split("@");
            return [mailId, domain];
        },
        splitBizNumber(bizNo) {
            // 숫자만 남기기
            bizNo = bizNo.replace(/\D/g, "");

            return [bizNo.slice(0, 3), bizNo.slice(3, 5), bizNo.slice(5)];
        },
        onlyPlusNumber(e) {
            const allowKeys = [
                'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'
            ];

            // 숫자 키 허용
            if (
                (e.key >= '0' && e.key <= '9') ||
                allowKeys.includes(e.key)
            ) {
                return;
            }

            // 한글 IME 조합 입력 감지
            if (e.key === 'Process' || e.keyCode === 229) {
                this.isComposing = true;
                e.preventDefault(); // ← 여기서 차단
                return;
            }

            e.preventDefault();
        },

        sanitizeNumber(value) {
            if (value === null || value === undefined) return '';

            let result = String(value).replace(/[^0-9]/g, '');

            // 선행 0 제거
            result = result.replace(/^0+/, '');

            // 전부 0만 입력한 경우 0 유지
            if (result === '' && /^0+$/.test(String(value))) {
                result = '0';
            }

            return result;
        },
        getNestedValue(path) {
            return path.split('.').reduce((obj, key) => {
                return obj ? obj[key] : '';
            }, this);
        },
        setNestedValue(path, value) {
            const keys = path.split('.');
            let target = this;

            for (let i = 0; i < keys.length - 1; i++) {
                const key = keys[i];

                if (target[key] === undefined || target[key] === null) {
                    this.$set(target, key, {});
                }

                target = target[key];
            }

            this.$set(target, keys[keys.length - 1], value);
        },
        onNumberInput(e, field) {
            const oldValue = String(this.getNestedValue(field) || '');
            let newValue = this.sanitizeNumber(e.target.value);

            if(this.isComposing){
                newValue = oldValue;
            }

            // 한글/문자 입력해서 숫자가 하나도 없으면 기존 값 유지
            if (e.target.value !== '' && newValue === '') {
                e.target.value = oldValue;
                return;
            }

            // 선행 0 제거
            newValue = newValue.replace(/^0+/, '');

            // 0만 입력한 경우는 0 유지
            if (newValue === '' && /^0+$/.test(e.target.value)) {
                newValue = '0';
            }

            this.setNestedValue(field, newValue);
            e.target.value = newValue;
            this.isComposing = false;
        },
        numberToKorean(num) {
            if (!num || isNaN(num)) return '';

            const units = ['', '만', '억', '조', '경'];
            const numbers = ['','일','이','삼','사','오','육','칠','팔','구'];
            const tens = ['', '십', '백', '천'];

            let result = '';
            let unitIndex = 0;

            while (num > 0) {
                let chunk = num % 10000;
                if (chunk !== 0) {
                    let chunkStr = '';
                    let i = 0;

                    while (chunk > 0) {
                        const digit = chunk % 10;
                        if (digit > 0) {
                            chunkStr = numbers[digit] + tens[i] + chunkStr;
                        }
                        chunk = Math.floor(chunk / 10);
                        i++;
                    }

                    result = chunkStr + units[unitIndex] + ' ' + result;
                }

                num = Math.floor(num / 10000);
                unitIndex++;
            }

            return result.trim() + ' 원';
        }
    }
})